import { useFlags } from '@missionlabs/feature-flags'

import { Features, useHasClientFeature } from './useHasClientFeature'

export const useHasFeature = (feature: Features) => {
    const flags = useFlags([feature])

    const isFeatureOnClient = useHasClientFeature(feature)
    const isEnabled = flags[`${feature}`]?.enabled ?? false

    return isEnabled && isFeatureOnClient
}
